export const config = {
  GA: "G-T8VRQDNJDE",
  defaultPasswordLength: 16,
};
